
  import { RequiredConfigVariable } from '@/services/integrations/types';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { Button } from '@/ui/components/Button';
  import BaseStep, { BaseStepProperties, BASE_STEP_PROPS } from './BaseStep.vue';
  import { computed, defineComponent, ref, watch } from 'vue';
  import { integrationsConfigService } from '@/services/integrations/integrationsConfigService';
  import { integrationsService } from '@/services/integrations/integrationsService';

  interface SelectSiteStepProperties extends BaseStepProperties {
    configVariable: RequiredConfigVariable;
  }

  export default defineComponent<SelectSiteStepProperties>({
    components: {
      Button,
      BaseStep,
    },
    props: [...BASE_STEP_PROPS, 'configVariable'],

    setup(props) {
      const store = useIntegrationDetailsStore();
      const { key } = props.configVariable;
      const instance = computed(() => store.instance);
      const loading = ref(false);
      const options = ref<Array<{ id: string; name: string }>>([]);
      const value = ref(store.getConfigVariable(key) as string|undefined);

      const submit = () => {
        if (!value.value) {
          return;
        }

        store.setConfigVariable(key, value.value);
        store.nextStep();
      };

      const fetchOptions = async () => {
        loading.value = true;

        try {
          const accessToken = await integrationsConfigService.getConnectionAccessToken(instance.value!);

          if (!accessToken) {
            console.error('SharePoint access token unavailable');

            return;
          }

          const result = await integrationsService.getSharePointSites(accessToken);

          if (!result) {
            console.error('Unable to fetch SharePoint sites');

            return;
          }

          options.value = result;
        } catch (e) {
          console.error(e);
        } finally {
          loading.value = false;
        }
      };

      watch(() => props.active, active => {
        if (active) {
          fetchOptions();
        }
      });

      return {
        options,
        value,
        submit,
        loading,
      };
    },
  });
